// extracted by mini-css-extract-plugin
export default {"root":"compactLeadFields_root__1T5-4"};